import { makeToast } from '@cognite/cogs-lab';
import type { TFunction } from 'i18next';
import type { NavigateFunction } from 'react-router-dom';

import type { CreatedAndFailedChecklists } from './create-checklists-sequentially';

export function showChecklistCreationToast(
  result: CreatedAndFailedChecklists,
  t: TFunction
) {
  const { createdChecklists, failedChecklists } = result;
  const successCount = createdChecklists.length;
  const failCount = failedChecklists.length;

  if (successCount > 0 && failCount === 0) {
    makeToast({
      body: t(
        'MOVED_TO_READY_SUCCESS',
        '{{ successCount }} checklists moved to Ready',
        { successCount }
      ),
      type: 'success',
    });
  } else if (failCount > 0) {
    makeToast({
      body: t(
        'MOVED_TO_READY_ERROR',
        `Some checklists didn't move to Ready. Try again.`
      ),
      type: 'warning',
    });
  }
}
